export default __webpack_public_path__ + "55faf4492a0acd4dff11b4ccb21c7a0c.png";